import React, { useCallback, useState } from 'react'
import { TandemAccountsDashboard } from './TandemAccountsDashboard'
import { TandemLicensePage } from './TandemLicensePage'

export const TandemPage = () => {
	// need a section for the license info and section for accounts

	const [currentIndex, setCurrentIndex] = useState(0)

	const handleTabIndexChanged = useCallback(
		(_event: React.SyntheticEvent, newValue: number) => {
			setCurrentIndex(newValue)
		},
		[],
	)

	const tabLabels = ['License', 'Accounts']

	const tabSelector = (index: number) => {
		if (index === 0)
			return (
				<TandemLicensePage
					tabLabels={tabLabels}
					onTabChanged={handleTabIndexChanged}
				/>
			)

		if (index === 1)
			return (
				<TandemAccountsDashboard
					tabLabels={tabLabels}
					onTabChanged={handleTabIndexChanged}
				/>
			)
	}

	return <>{tabSelector(currentIndex)}</>
}
